export const LOGIN = "/auth/login"
export const LOGOUT = "/auth/logout"

export const FORGOT_PASSWORD = "/auth/reset-request"
export const RESET_PASSWORD = "/auth/reset-password"
export const FETCH_TOKEN = "/auth/token/:param"

export const REGISTER = "/auth/register"
export const CHECK_EMAIL = "/auth/emails/verify"
